import classes from './ChatBanner.module.scss';
import Image from 'next/image';

export default function ChatBanner(props) {
    /**
     * Chat Banner expects props at object key 0
     */
    if (!props[0]) return null;

    const chatBannerImage = props[0]?.image;

    const { url, height, width } = chatBannerImage?.data?.attributes;

    return (
        <div className={classes.oChatBannerContainer}>
            <figure className={classes.aChatBannerImage}>
                <Image
                    src={url}
                    alt={`Chat Banner`}
                    width={width}
                    height={height}
                    className={classes.aImage}
                    aria-hidden="true"
                    layout="responsive"
                    priority="true"
                />
            </figure>
        </div>
    );
}
